import React, { useEffect } from "react";
import ContactUs from "../ContactUs/ContactUs";
import Reviews from "../Reviews/Reviews";
import Announcement from "./Announcement/Announcement";
import ApplicationForm from "./ApplicationForm/ApplicationForm";
import Banner from "./Banner/Banner";
import FeaturedProducts from "./FeaturedProducts/FeaturedProducts";

const Home = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    script.defer = true;
    script.setAttribute("data-use-service-core", "");

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="">
      {/* <Announcement /> */}
      <div className="">
        <Announcement label="FREE STANDARD DELIVERY ON ORDERS OVER £50" />
      </div>
      <Banner />
      <div className="mb-[50px] lg:mb-[50px] xl:mb-[70px]">
        <Announcement label="Enjoy £5 off when you spend over £30" />
      </div>

      <FeaturedProducts />
      {/* <About /> */}
      <ContactUs />
      <Reviews></Reviews>

      <ApplicationForm />
      {/* <Newsletter /> */}
      {/* <div class="elfsight-app-b96e8037-b0f9-4db3-9c23-ed026dd0fd66" data-elfsight-app-lazy></div>
       */}
    </div>
  );
};

export default Home;

// https://www.ebay.com/fdbk/feedback_profile/Emporium-central
// https://www.depop.com/emporium_central/ (click on feedback)
// Get all reviews from these two and display them as a carousel on homepage below have an item to sell?
